import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import { getAccessId } from './util/auth';
import './assets/style.css' 

import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$axiso = axios

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (getAccessId()) {
			next()
		} else {
			next({
			  path: '/signin'
			})
		}
	} else {
		next()
	}
	
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
